import { AuthenticatedTemplate } from "@azure/msal-react";
import LoginForm from "../../components/login/LoginForm";
import { Navigate } from "react-router-dom";

const Login = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <Navigate to="/" />
      </AuthenticatedTemplate>

      <LoginForm />
    </>
  );
};

export default Login;
